import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <div className="center-pad">
      <h1 style={{ fontSize: 48, margin: '0 0 8px' }}>404</h1>
      <p>That page doesn't exist (yet — check the <Link to="/roadmap">roadmap</Link>).</p>
      <Link to="/">← Back home</Link>
    </div>
  );
}
